import { getTranslatedText, useIntl } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Button, Card, TextField, TextStyle } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const INTERCOM_Z_INDEX = 2147483000;

const FeedbackTooltipWrap = styled.div`
  z-index: ${INTERCOM_Z_INDEX + 10006};
  width: 360px;
  right: -80px;
  bottom: 35px;
`;

function AIFeedbackTooltip({ onSend, onClose }) {
  const [feedbackText, setFeedbackText] = useState('');
  const [hadSentFeedback, setHadSentFeedback] = useState(false);
  const intl = useIntl();

  return (
    <FeedbackTooltipWrap className="ai-feedback-tooltip position-absolute black-color">
      <Card padding="sizeSmall">
        <div className={`fx g10 col ${hadSentFeedback ? 'items-center' : ''}`}>
          {!hadSentFeedback ? (
            <>
              <div className="fx">
                <TextStyle>
                  <FormattedMessage id="ticket.sideConversation.feedback.title" />
                </TextStyle>
                <div onClick={onClose} className="mlauto">
                  <SVGIcon name="Close" />
                </div>
              </div>
              <div className="content">
                <TextField
                  value={feedbackText}
                  onChange={(val) => {
                    setFeedbackText(val);
                  }}
                  placeholder={getTranslatedText(
                    intl,
                    'ticket.sideConversation.feedback.placeholder'
                  )}
                  type="text"
                  bgTransparent
                  multiline
                  maxLength={255}
                  maxHeight={80}
                />
              </div>
              <div className="mlauto w-fit">
                <Button
                  disabled={!feedbackText}
                  plain
                  onClick={() => {
                    onSend(feedbackText);
                    setHadSentFeedback(true);
                  }}
                >
                  <FormattedMessage id="common.send" />
                </Button>
              </div>
            </>
          ) : (
            <>
              <SVGIcon
                name="CircleTickOutlineMinor"
                color="#77BA6D"
                size="xl"
              />
              <TextStyle variation="subdued">
                <FormattedMessage id="ticket.sideConversation.feedback.done" />
              </TextStyle>
            </>
          )}
        </div>
      </Card>
    </FeedbackTooltipWrap>
  );
}

export default AIFeedbackTooltip;
